module.exports = __webpack_public_path__ + "static/mortgagebot-profile-69dc2b0aed4a87f92ad204397c0e42eb.png";